import { Outlet } from "react-router";

export default function LayoutAuth() {
	return (
		<main className="min-h-screen flex justify-center p-4 sm:p-8 bg-[#fafafa]">
			<div className="max-w-240 w-full my-auto flex justify-center">
				<Outlet />
			</div>
		</main>
	);
}
